import React from 'react';
import { Card, Typography } from 'antd';

const fmt = (n) => new Intl.NumberFormat('ko-KR').format(n);

export default function ExpenseCard({ expense, onClick }) {
  return (
    <Card
      size="small"
      hoverable
      style={{ marginBottom: 8 }}
      bodyStyle={{ padding: 14 }}
      onClick={onClick}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{
          width: 40, height: 40, borderRadius: 10, background: '#EEF4FB',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
        }}>
          {expense.category_name?.[0] || '?'}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Typography.Text strong ellipsis style={{ display: 'block' }}>
            {expense.title}
          </Typography.Text>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            {expense.category_name} · {expense.method_name}
            {expense.user_name ? ` · ${expense.user_name}` : ''}
          </Typography.Text>
        </div>
        <div style={{ textAlign: 'right' }}>
          <Typography.Text strong style={{ color: '#E53935' }}>
            -{fmt(expense.amount)}원
          </Typography.Text>
          <div style={{ fontSize: 11, color: '#999' }}>{expense.used_at}</div>
        </div>
      </div>
    </Card>
  );
}
